// Bağlantı adresini kaydedilebilir hâle getirir.
//
// Tür listesi kalkınca şema üretimi de kalktı: eskiden 'phone' seçildiğinde `tel:` eki kod
// tarafından geliyordu. Simge artık serbest bir emoji ve hiçbir şema taşımıyor, ama kullanıcıdan
// `tel:+905071234567` yazmasını beklemek gerçekçi değil — düz numara yazıyor ve menü onu
// `https://5075971811` diye bir adrese çeviriyor: hem ölü bağlantı, hem şube kartında telefon
// çipi çıkmıyor (tespit adresin şemasına bakıyor).
//
// Dönüşüm GİRİŞTE yapılıyor, menüde değil: menü tarafı adresi olduğu gibi kullanmalı, tahmin
// yürütmemeli. Kullanıcı alandan çıkınca sonucu gözüyle görüyor.

// Şeması olan adrese dokunulmuyor. `(?!\d)` port'u şema sanmayı engelliyor (site.com:8080).
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:(?!\d)/i;
const LOOKS_LIKE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Telefon sayılması için: yalnızca rakam ve ayraç, ve makul uzunlukta. 6 hane bir numara değil,
// 16 hane de değil — aradaki aralık uluslararası numaraları kapsıyor.
const PHONE_CHARS = /^[+()\-\s.\d]+$/;
const MIN_PHONE_DIGITS = 7;
const MAX_PHONE_DIGITS = 15;

// Kiracıların tamamı TR ve panel Türkçe. Ülke kodu taşımayan bir numara girildiğinde varsayılan
// bu; başında + ya da 00 olan numara zaten kendi ülkesini söylüyor ve dokunulmuyor.
const DEFAULT_COUNTRY_CODE = "90";

const toTel = (digits) => {
  if (digits.startsWith("00")) {
    return `+${digits.slice(2)}`;
  }

  // Baştaki 0 şehir içi/şebeke ön eki; uluslararası biçimde yeri yok.
  if (digits.startsWith("0")) {
    return `+${DEFAULT_COUNTRY_CODE}${digits.slice(1)}`;
  }

  // 10 hane ve sıfırsız: ön eki atılmış yerel numara (5075971811).
  if (digits.length === 10) {
    return `+${DEFAULT_COUNTRY_CODE}${digits}`;
  }

  return `+${digits}`;
};

// Harita bağlantısı mı? Menüdeki karşılığıyla (menu helpers/branchLinks isMapsHref) AYNI kural
// olmak zorunda: panel bu adresi "Konum" yuvasına koyuyor, menü ise tam da bu testle onu ikon
// satırından çıkarıp şube kartındaki yol tarifi çipine veriyor. İkisi ayrışırsa bağlantı ya iki
// yerde birden ya da hiçbir yerde görünür.
export const isMapsHref = (href) =>
  /(google\.[a-z.]+\/maps|maps\.app\.goo\.gl|goo\.gl\/maps|yandex\.[a-z.]+\/maps|maps\.apple\.com)/i.test(
    href ?? "",
  );

// Bu adres CEP telefonu mu? WhatsApp önerisi buna bağlı.
//
// Sabit hatta WhatsApp yok: `tel:+902161234567` için çip basmak, tıklayınca "bu numara WhatsApp'ta
// kayıtlı değil" ekranına düşen ölü bir bağlantı demek. TR'de cep numaraları ülke kodundan sonra
// 5 ile başlıyor, sabit hatlar 2/3/4 ile — ayrım bu kadar basit.
//
// Cep olması WhatsApp'ta olduğunu GARANTİ etmiyor, o yüzden karar kullanıcının: panel yalnızca
// öneriyor, otomatik eklemiyor.
export const isMobileTel = (value) => /^tel:\+905\d{9}$/.test(value ?? "");

// Cep numarasından WhatsApp adresi. wa.me ülke kodlu ve artısız/sıfırsız numara istiyor.
export const waLinkFromTel = (value) =>
  `https://wa.me/${(value ?? "").replace(/\D/g, "")}`;

export const normalizeLinkValue = (value) => {
  const raw = (value ?? "").trim();

  if (!raw || HAS_SCHEME.test(raw)) {
    return raw;
  }

  if (LOOKS_LIKE_EMAIL.test(raw)) {
    return `mailto:${raw}`;
  }

  if (PHONE_CHARS.test(raw)) {
    const digits = raw.replace(/\D/g, "");

    if (
      digits.length >= MIN_PHONE_DIGITS &&
      digits.length <= MAX_PHONE_DIGITS
    ) {
      return `tel:${toTel(digits)}`;
    }
  }

  // Geriye kalan: çıplak alan adı ya da tanınmayan bir şey. Menü `https://` ekliyor, burada
  // tahmin yürütmeye gerek yok.
  return raw;
};
